<template>
<div>
<!-- 活动形式 -->
  <el-row :span="24" class="order_toolbar toolbar pad_left">
    <!-- 排版左 -->
    <el-col :span="4">
      <!-- 活动形式-详情 -->
      <div class="activityFormClass">
        <p class="hdxsClass">活动形式</p>
        <el-tabs tab-position="left" style="height: 200px;" v-model="activityId" @tab-click="handleCurrentChange">
          <el-tab-pane v-for="(item, index) in leftActivityFormList" :key="index" :label="item.ActivityFormName" 
            :name="item.ActivityFormId" :data-actid="item.ActivityId"/>
        </el-tabs>
      </div>
    </el-col>
    <!-- 排版右 -->
    <el-col :span="20">
      <!--列表-->
      <el-col class="order_content main_container">
        <section class="model_section" style="margin-bottom: 10px">
          <el-col :span="14">
            <p class="model_top_title">{{activitiesName}}</p>
          </el-col>
          <el-col :span="10">
            <div class="divBtn">
              <!-- <button class="setUpCoCreation" @click="endSetUp()"
                v-if="activityId == 4 && !(isEdit == 2 || isEdit == 3)"> 共创推广优惠券佣金上限: 
                <b v-if="this.shangxian">{{this.shangxian}}</b> <b v-else> 0 </b> 元
              </button> -->
              <button class="redBackground" @click="addRelatedBrand()" v-if="(activityId == 1 || activityId == 2 || activityId == 3 || activityId == 4) && !(isEdit == 2 || isEdit == 3)"> 新增 </button>
              <button class="redBackground" @click="addRelatedBrand()" v-if="(activityId == 5 || activityId == 6 || activityId == 7) && (dataList.length != 1 || dataList == null)"> 新增 </button>
              <el-button type="danger" @click="addRelatedBrand()" v-if="activityId == 8">新增</el-button>
              <el-button type="danger" @click="addOneRobbery()" v-if="activityId == 9">新增</el-button>
            </div>
          </el-col>
        </section>
        <!-- table 列表 -->
        <div class="table_container">
          <div class="table_inner_container" style="height: auto">
            <el-table :data="dataList" class="invoice_tab" stripe border style="height: auto;">
              <el-table-column label="序号" align="center" width="50" key="1">
                <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
              </el-table-column>
              <template v-if="activityId != 4">
                <el-table-column label="店铺" align="center" v-if="activityId == 1 || activityId == 2 || activityId == 3">
                  <template scope="scope">
                    <span class="spanList" :title="scope.row.brandName">{{ scope.row.brandName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="商品编码" align="center" v-if="activityId == 1 || activityId == 2 || activityId == 3">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.goodModelCode }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" align="center" v-if="activityId == 1 || activityId == 2 || activityId == 3">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.title }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="市场价" align="center" v-if="activityId == 1 || activityId == 2 || activityId == 3">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.marketPrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="礼品名称" align="center" v-if="activityId == 5 || activityId == 6 || activityId == 7">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="礼品数量" align="center" v-if="activityId == 5 || activityId == 6 || activityId == 7">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.number }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="核销时间" align="center" v-if="activityId == 5">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.datetime }}</span>
                  </template>
                </el-table-column>
                <div v-if="activityId == 8">
                  <el-table-column label="店铺" align="center">
                    <template scope="scope">{{ scope.row.shopname }}</template>
                  </el-table-column>
                  <el-table-column label="商品编码" align="center">
                    <template scope="scope">{{ scope.row.goodscode }}</template>
                  </el-table-column>
                  <el-table-column label="商品名称" align="center">
                    <template scope="scope">{{ scope.row.goodsname }}</template>
                  </el-table-column>
                  <el-table-column label="商品类型" align="center">
                    <template scope="scope">{{ scope.row.goodstypename }}</template>
                  </el-table-column>
                  <el-table-column label="状态" align="center">
                    <template scope="scope">{{ scope.row.isonsalename }}</template>
                  </el-table-column>
                </div>
                <el-table-column label="活动号码" align="center" v-if="activityId == 9">
                  <template scope="scope">{{ scope.row.smackercode }}</template>
                </el-table-column>
              </template>
              <!--  v-if="activityId == 4" -->
              <template v-else>
                <el-table-column label="优惠券名称" prop="name" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="面值" prop="facevalue" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.facevalue }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="使用条件" prop="usethreshold" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.usethreshold }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="售价" prop="price" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="适用店铺" prop="shopname" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.shopname }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="优惠券数量" prop="number" align="center">
                  <template scope="scope">
                    <span class="spanList">{{ scope.row.number }}</span>
                  </template>
                </el-table-column>
              </template>
              
              <el-table-column label="促销价" align="center" v-if="activityId == 1">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.promotionPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="秒杀价" align="center" v-if="activityId == 2">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.seckillPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" align="center" v-if="activityId == 2">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.seckillStock }}</span>
                </template>
              </el-table-column>
              <el-table-column label="团购价" align="center" v-if="activityId == 3">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.groupPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="成团人数" align="center" v-if="activityId == 3">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.groupNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column label="佣金" align="center" v-if="activityId == 2 || activityId == 3">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.commissionRate }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="甄惠装价" align="center" v-if="activityId == 5">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.tzrPrice }}</span>
                </template>
              </el-table-column> -->
              
              <el-table-column label="操作" fixed="right" width="235" align="center" v-if="isEdit != 2">
                <template scope="scope">
                  <span class="handle" v-if="isEdit != 3 && activityId != 8 && activityId != 9" @click="editActivity(scope.row)">
                    <i class="el-icon-edit-outline"></i> 编辑
                  </span>
                  <span class="handle" v-if="isEdit != 3" @click="deleteBrand(scope.row)">
                    <i class="el-icon-delete"></i> 删除
                  </span>
                  <span class="handle" v-if="activityId == 9" @click="spUpordown(scope.row, 1)" v-show="scope.$index > 0">
                    <i class="el-icon-upload2" /> 向上
                  </span>
                  <span class="handle" v-if="activityId == 9" @click="spUpordown(scope.row, 2)" v-show="scope.$index < dataList.length - 1">
                    <i class="el-icon-download" /> 向下
                  </span>
                  <span class="handle" v-if="isEdit == 3" @click="seeinfo(scope.row, 3)">
                    <i class="el-icon-view"></i> 查看
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="padding-left: 0; margin: 22px auto; text-align: center">
            <button type="button" @click="toPrevStep"
              class="el-button el-button--default cancle normal_btn">
              上一步
            </button>
            <button type="button" @click="toNextStep"
              class="el-button el-button--default search_btn normal_btn">
              下一步
            </button>
          </div>
        </div>
      </el-col>
    </el-col>
  </el-row>
  <!-- 共创推广优惠券佣金上限-弹框 -->
  <el-dialog title="共创推广优惠券佣金上限" :visible.sync="isToExamine" class="add_order_cancle" width="30%">
    <el-form>
      <el-form-item style="width:100%">
        <el-input v-model="upperLimit" placeholder="请输入共创推广优惠券佣金上限" maxlength="20"/>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left:0;text-align:center">
      <button type="button" @click="isToExamine = false"
        class="el-button el-button--default cancle normal_btn">取消</button>
      <button type="button" @click="editSubmit()"
        class="el-button el-button--default search_btn normal_btn">保存</button>
    </div>
  </el-dialog>
  <!-- 幸运购-弹框 -->
  <el-dialog title="幸运购" :visible.sync="yiyuan" class="add_order_cancle" width="25%">
    <el-form>
      <el-form-item style="width:100%">
        <el-input v-model="yyqHdhm" placeholder="请输入幸运购活动号码    例：230307001" maxlength="11"/>
      </el-form-item>
      <div style="line-height: 10px;padding:0 0 10px 5px;">
        <b style="color: #F56C6C;">温馨提示：</b>
        <p>如需添加幸运购活动号码，请联系400-1577-588。</p>
      </div>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <button type="button" @click="yiyuan = false"
        class="el-button el-button--default cancle normal_btn">取消</button>
      <button type="button" @click="yyqSubmit()"
        class="el-button el-button--default search_btn normal_btn">保存</button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { getSpecialOfferGoodsList, getSortedSpecialGoodsList, getRemoveSpecialOfferGoods, // 特价相关接口
  getSeckillGoodsList, getSortedSeckillGoodsList, getRemoveSeckillGoods, // 秒杀相关接口
  getGroupBuyGoodsList, getSortedGroupBuyGoodsList, getRemoveGroupBuyGoods, // 团购相关接口
  getlistcoupon, getSortedCouponList, getRemoveCoupon, getBatchUpdateCouponCommissionLimit, // 优惠券相关接口
  getReservationGoodsList, getSortedReservationGoodsList, getRemoveReservationGoods, // 预约签到礼相关接口
  getToStoreGiftList, delToStoreGift, getContinuityOrderList, delContinuityOrderGift, // 到店打卡礼&连单礼相关接口
  getCheckReservationGoodsIsAllowToInsert, specialpriceGetchoosegoods, specialpriceDelgoods, // 特价商品 相关接口
  smackerGetchoosegoods, smackerSavegoods, smackerDelgoods, smackerGoodssort } from "../../api/activityFormList";
  export default {
  name: "activityFormList",
  data() {
    return {
      editActivityId: "", // 活动id
      // 活动形式侧边菜单
      leftActivityFormList: [],
      activityId: 1, // 获取点击项id
      activitiesName: '活动商品', // 活动名称
      // 列表
      dataList: [],
      shangxian: "",
      isEdit: "",
      isToExamine: false, // 设置共创佣金上限-弹框
      upperLimit: "", // 上限
      upperLimitNew: "0",
      newType: '',
      newLmhd: '',
      yiyuan: false, // 幸运购-弹框
      yyqHdhm: '', // 幸运购-活动号码
    };
  },
  props:{
    whichRole:{
      type:Boolean,
      default:true
    }
  },
  methods: {
    // 上一步
    toPrevStep() {
      this.$emit("toPrevStep", !this.whichRole || this.newLmhd?0:1,this.isEdit==0?true:false);
    },
    // 下一步
    toNextStep() {
      this.$emit("toNextStep", 3);
    },
    initComponent(val,type,activeListData, lmhd,sponsorType,activityTypeFrom) {
      this.newType = sponsorType;
      this.editActivityId = val;
      this.isEdit = type;
      
      this.newLmhd = localStorage.getItem("lianmengId"); // 联盟活动
      this.activityId = sponsorType?sponsorType:activeListData[0].ActivityFormId; // 获取 活动id 第一个
      this.activitiesName = activeListData[0].ActivityFormName; // 获取 活动名称 第一个
      this.leftActivityFormList = activeListData;
      this.implementMethod();
    },
 
    implementMethod(){
      // 特价
      if(this.activityId == 1) {
        this.endSpecialOffer();
      }
      // 秒杀
      if(this.activityId == 2) {
        this.seckill();
      }
      // 团购
      if(this.activityId == 3) {
        this.groupBuying();
      }
      // 优惠券
      if(this.activityId == 4) {
        this.coupon();
      }
      // 预约签到礼
      if(this.activityId == 5) {
        this.appointmentCheck();
      }
      // 到店打卡礼
      if(this.activityId == 6) {
        this.dddklList();
      }
      // 连单礼
      if(this.activityId == 7) {
        this.dllList();
      }
      // 特价商品
      if(this.activityId == 8) {
        this.tjspList();
      }
      // 幸运购
      if(this.activityId == 9) {
        this.yyqList();
      }
    },
    // 点击活动形式
    handleCurrentChange(val) {
      let actid = val.$attrs['data-actid']  // 活动id
      this.activitiesName = val.label // 获取活动名称
      // this.activityId = val ? formid : this.activityId;
      this.implementMethod();
    },
    // 查询特价
    endSpecialOffer() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getSpecialOfferGoodsList(addParams).then((data) => {
        this.dataList = data.ResultObj;
      });
    },
    // 查询秒杀
    seckill() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getSeckillGoodsList(addParams).then((data) => {
        this.dataList = data.ResultObj;
      });
    },
    // 查询团购
    groupBuying() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getGroupBuyGoodsList(addParams).then((data) => {
        this.dataList = data.ResultObj;
      });
    },
    // 查询 优惠券
    coupon() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getlistcoupon(addParams).then((data) => {
        if (data.resultCode == 1) {
          
          // if(this.dataList) {
          //   this.shangxian = this.dataList[0].commissionCap;
          // }
          this.shangxian = data.RowsCount; // 获取回显优惠券佣金上限参数值
          
          this.dataList = data.resultObj;
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 预约签到礼
    appointmentCheck() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getReservationGoodsList(addParams).then(data => {
        if (data.ResultCode == 1) {
          this.dataList = data.ResultObj;
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 到店打卡礼
    dddklList() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getToStoreGiftList(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 连单礼
    dllList() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      getContinuityOrderList(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 特价商品
    tjspList() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      specialpriceGetchoosegoods(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.list;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      });
    },
    // 查询 幸运购
    yyqList() {
      let addParams = {
        activityId: this.editActivityId, // 活动id
      };
      smackerGetchoosegoods(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.list;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      });
    },
    // 幸运购-新增
    addOneRobbery() {
      this.yiyuan = true;
      this.yyqHdhm = '';
    },
    // 幸运购-保存
    yyqSubmit() {
      let obj = {
        activityId: this.editActivityId, // 活动id
        smackerCode: this.yyqHdhm, // 活动号码
        operatorId: localStorage.Id, // 操作人id
      };
      smackerSavegoods(obj).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            // text: "添加成功",
            text: data.resultMsg,
          });
          this.yiyuan = false;
          this.yyqHdhm = '';
          this.yyqList(); // 刷新幸运购列表
        }
      });
    },
    // 新增
    addRelatedBrand() {
      this.isFormEditOrAdd=0;
      // editActivityId 活动id
      // activityId 活动形式id
      if(this.activityId == 5) {
        let addParams = {
          activityId: this.editActivityId, // 活动id
        };
        getCheckReservationGoodsIsAllowToInsert(addParams).then((data) => {
          // 允许创建
          if (data.ResultCode == 1) {
            this.$emit("showWhichAddActiveForm",this.editActivityId, this.activityId,0, this.newType);
          } else {
            // 不允许创建
            this.$swal({
              type: "warning",
              text: data.ResultMsg,
            });
          }
        });
      } else {
        this.$emit("showWhichAddActiveForm",this.editActivityId, this.activityId,0, this.newType);
      }

    },
    // 编辑
    editActivity(row) {
      let soId = row.id;
      this.isFormEditOrAdd = 1;
      this.$emit("showWhichAddActiveForm", this.editActivityId,this.activityId,soId, this.newType);
    },
    // 查看
    seeinfo(row, type) {
      let soId = row.id;
      this.isFormEditOrAdd = 1;
      this.$emit("showWhichAddActiveForm", this.editActivityId,this.activityId,soId, type, this.newType);
    },
    // 操作向上 & 向下
    spUpordown(row, val) {
      // 特价-排序
      if(this.activityId == 1) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          specialOfferGoodsId: row.id, // 特价商品列表id！！！！
          direction: val, // 操作类型；1：向上、2：向下
        };
        getSortedSpecialGoodsList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.endSpecialOffer();
          }
        });
      }
      // 秒杀-排序
      if(this.activityId == 2) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          goodsId: row.id, // 秒杀商品主键id
          direction: val, // 1=向上；2=向下
        };
        getSortedSeckillGoodsList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.seckill();
          }
        });
      }
      // 团购-排序
      if(this.activityId == 3) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          goodsId: row.id, // 团购商品主键id
          direction: val, // 1=向上；2=向下
        };
        getSortedGroupBuyGoodsList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.groupBuying();
          }
        });
      }
      // 优惠券-排序
      if(this.activityId == 4) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          couponId: row.id, // 活动优惠券主键id
          direction: val, // 1=向上;2=向下
        };
        getSortedCouponList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.coupon();
          }
        });
      }
      // 预约签到礼-排序
      if(this.activityId == 5) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          goodsId: row.id, // 预约礼商品主键id
          direction: val, // 1=向上;2=向下
        };
        getSortedReservationGoodsList(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.appointmentCheck();
          }
        });
      }
      // 幸运购-排序
      if(this.activityId == 9) {
        let sortVariable = {
          activityId: this.editActivityId, // 活动id
          sort: row.sort, // 排序值
          sortType: val, // 排序类型 1=上移 2=下移
          operatorId: localStorage.Id, // 操作人id
        };
        smackerGoodssort(sortVariable).then((data) => {
          if (data.ResultCode == 1) {
            this.yyqList();
          }
        });
      }
    },
    // 单条删除-列表数据
    deleteBrand(row) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          // 特价 - 删除
          if(this.activityId == 1) {
            let deleteVariable = {
              specialOfferGoodsId: row.id,
            };
            getRemoveSpecialOfferGoods(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "特价-删除 操作成功",
                });
                this.endSpecialOffer();
              }
            });
          }
          // 秒杀 - 删除
          if(this.activityId == 2) {
            let deleteVariable = {
              goodsId: row.id,
            };
            getRemoveSeckillGoods(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "秒杀-删除 操作成功",
                });
                this.seckill();
              }
            });
          }
          // 团购 - 删除
          if(this.activityId == 3) {
            let deleteVariable = {
              goodsId: row.id,
            };
            getRemoveGroupBuyGoods(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "团购-删除 操作成功",
                });
                this.groupBuying();
              }
            });
          }
          // 优惠券 - 删除
          if(this.activityId == 4) {
            let deleteVariable = {
              activityCouponId: row.id,
            };
            getRemoveCoupon(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "优惠券-删除 操作成功",
                });
                this.coupon();
              }
            });
          }
          // 预约签到礼 - 删除
          if(this.activityId == 5) {
            let deleteVariable = {
              goodsId: row.id,
            };
            getRemoveReservationGoods(deleteVariable).then((data) => {
              if (data.ResultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "预约签到礼-删除 操作成功",
                });
                this.appointmentCheck();
              }
            });
          }
          // 到店打卡礼 - 删除
          if(this.activityId == 6) {
            delToStoreGift('', row.id).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "到店打卡礼-删除 操作成功",
                });
                this.dddklList();
              }
            });
          }
          // 连单礼 - 删除
          if(this.activityId == 7) {
            delContinuityOrderGift('', row.id).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "连单礼-删除 操作成功",
                });
                this.dllList();
              }
            });
          }
          // 特价商品 - 删除
          if(this.activityId == 8) {
            let obj = {
              activityId: this.editActivityId, // 活动id
              shopId: row.shopid, // 店铺ID
              goodsIds: row.goodsid, // 店铺商品ID，多个商品用英文逗号隔开
              operatorId: localStorage.Id, // 操作人id
            }
            specialpriceDelgoods(obj, row.id).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "特价商品-删除 操作成功",
                });
                this.tjspList();
              }
            });
          }
          // 幸运购 - 删除
          if(this.activityId == 9) {
            let obj = {
              activityId: this.editActivityId, // 活动id
              asgId: row.asgid, // 幸运购活动商品主键
              operatorId: localStorage.Id, // 操作人id
            }
            smackerDelgoods(obj, row.id).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "幸运购-删除 操作成功",
                });
                this.yyqList();
              }
            });
          }
        }
      });
    },
    // 设置共创
    endSetUp() {
      this.isToExamine = true;
      this.upperLimit = "";
    },
    // 保存按钮
    editSubmit() {
      if(this.upperLimit == ""){
        this.$swal({
          type:'warning',
          text: '请输入上限值',
        })
        return false;
      }
      var loginParams = {
        activityId: this.editActivityId, // 活动id
        commissionCap: this.upperLimit, // 佣金上限,取值范围:0-9999999
      };
      getBatchUpdateCouponCommissionLimit(loginParams).then(data => {
        if (data.ResultCode == 1) {
          this.$swal({
            text: "修改成功",
            type: "success"
          })
          this.upperLimitNew = data.ResultObj;
        } else if(data.ResultCode == 4) {
          this.$swal({
            text: "无数据",
            type: "warning"
          })
          this.upperLimitNew = data.ResultObj;
        } else {
          this.$swal({
            text: data.ResultMsg,
            type: "warning"
          })
        }
        this.isToExamine = false;
        this.coupon();
      })
    }
  },
};
</script>
<style scoped>
.activityFormClass {
  /* height: calc(100vh - 150px); */
  height: calc(595px - 1px);
  margin-top: 20px;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  overflow: hidden;
}
.divBtn {
  height: 40px;
  text-align: right;
  margin-right: 20px;
  margin-bottom: 5px;
}
/* 设置共创按钮 */
.setUpCoCreation {
  width: 260px;
  height: 35px;
  line-height: 33px;
  font-size: 14px;
  background-color: #F56C6C;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
  margin-right: 10px;
}
/* 新增按钮 */
.redBackground {
  width: 80px;
  height: 35px;
  line-height: 33px;
  font-size: 14px;
  background-color: #F56C6C;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
}
/* 活动形式 */
.hdxsClass {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #d6d6d6;
  text-align: center;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// activityFormList.vue?efd7ae10